import type { ProductTaxonomyRenameDefinition } from '../types';

export const reportsRename = {
  copy: {
    'nav.review.analysis': {
      current: 'Analysis',
      future: 'Reports',
    },
  },
  routes: {
    'analysis.index': {
      current: '/workspaces/:workspaceId/journeys/analysis',
      future: '/workspaces/:workspaceId/journeys/reports',
    },
  },
  sideNavItemIds: {
    analysis: 'reports',
  },
} as const satisfies ProductTaxonomyRenameDefinition;
